import * as React from 'react';

import { DialogRoute } from 'bernie-core';
import { Layer } from 'bernie-view';

import { useLocalization } from '@shared-ui/localization-context';

import { InfoModal } from 'components/common/info-modal';

export interface DisclaimerDialogProps {
  dialogId: string;
  dialogType: string;
  disclaimerText: string;
  handleClose: () => void;
  innerHTML: boolean;
  layerId: string;
  disclaimerTextId: string;
}

export const DisclaimerDialog: React.FunctionComponent<DisclaimerDialogProps> = ({
  dialogId,
  dialogType,
  disclaimerText,
  handleClose,
  innerHTML,
  layerId,
  disclaimerTextId,
}) => {
  const l10n = useLocalization();

  return (
    <DialogRoute id={dialogId} type={dialogType}>
      <Layer id={layerId} onDismiss={handleClose}>
        <InfoModal closeA11yLabel={l10n.formatText('close')} onClose={handleClose}>
          {innerHTML ? (
            <p dangerouslySetInnerHTML={{ __html: disclaimerText }} data-stid={disclaimerTextId} />
          ) : (
            <p data-stid={disclaimerTextId}>{disclaimerText}</p>
          )}
        </InfoModal>
      </Layer>
    </DialogRoute>
  );
};
DisclaimerDialog.displayName = 'DisclaimerDialog';
